import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRouteLogin = () => {
  const tokenRedux = useSelector((state) => state.auth.token);

  if (tokenRedux) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
};

export default ProtectedRouteLogin;
